export default __webpack_public_path__ + "static/image-61-d06317fcf11c7446b2a9e4d59f1e036f.jpg";